import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./Theme";
import toast, { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";

export const notify = (message, type = "success") => {
  let icon;
  if (type === "info") {
    type = "success";
    icon = "📌";
  }
  toast.dismiss();
  toast[type](message, {
    duration: 3000,
    style: {
      borderRadius: "10px",
      // background: "#333",
      // color: "#fff",
      direction: "rtl",
      zIndex: 1000000,
    },
    icon: icon,
  });
};

export default function App() {
  console.log("V.1.0.3 || 1404/12/06");
  return (
    <>
      <HelmetProvider>
        <Toaster />
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </HelmetProvider>
    </>
  );
}
